// extracted by mini-css-extract-plugin
module.exports = {"resultWrapper":"styles_resultWrapper__2hKtX","open":"styles_open__2H3KO"};